import { gql } from "@apollo/client";

export const GET_OPT_IN_REQUESTS = gql`
  query GetInitiativesOptinRequests($organizationId: String!) {
    getInitiativesOptinRequests(organizationId: $organizationId) {
      id
      initiativeId
      organizationId
      status
      createdAt
      initiativeOwnerId
      initiativeAddress
      initiativeName
      organization {
        name
        id
      }
    }
  }
`;
